var map = {
	"./icon-arrow.svg": 95361,
	"./icon-close.svg": 15686,
	"./icon-copy.svg": 38385,
	"./icon-edit.svg": 87038,
	"./icon-lfg.svg": 4015,
	"./icon-menu.svg": 55435,
	"./icon-ok.svg": 63480,
	"./icon-rank.svg": 9816,
	"./icon-refresh.svg": 30303,
	"./icon-sigh.svg": 44791,
	"./icon-telegram.svg": 29611,
	"./icon-user.svg": 14219,
	"./icon-users.svg": 89282,
	"./icon-wallet.svg": 81165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;